/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index input to autogenerate all the components and extensions
 * Used by "prepareInputs"
 */

import Input from './input/Input'
export * from './input/Input'
export default Input
